import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";

interface IPostAccountSetupMitIdStartResponse {
  accessUrl: string;
}

interface IPostAccountSetupPasswordBody {
  token: string;
  password: string;
}

export const accountSetupMagicLinkApiKey = "accountSetupMagicLinkApi";
export const accountSetupMagicLinkApi = createApi({
  reducerPath: accountSetupMagicLinkApiKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl(), credentials: "include" }),
  endpoints: (builder) => ({
    getAccountSetupValidation: builder.query<void, { token: string }>({
      query: ({ token }) => ({
        url: "/account-setup/validate",
        headers: { [httpHeaders.magicToken]: token },
      }),
    }),
    postAccountSetupMitIdStart: builder.mutation<IPostAccountSetupMitIdStartResponse, { token: string }>({
      query: ({ token }) => ({
        url: "/account-setup/mitid/start",
        method: "POST",
        headers: { [httpHeaders.magicToken]: token },
      }),
    }),
    postAccountSetupPassword: builder.mutation<void, IPostAccountSetupPasswordBody>({
      query: ({ token, password }) => ({
        url: "/account-setup/password",
        method: "POST",
        headers: { [httpHeaders.magicToken]: token },
        body: { password },
      }),
    }),
  }),
});

export const {
  useGetAccountSetupValidationQuery,
  usePostAccountSetupMitIdStartMutation,
  usePostAccountSetupPasswordMutation,
} = accountSetupMagicLinkApi;
